import React from "react";
import img from "../../assets/team/team8.png";

function Joanah() {
  return (
    <div className="bg-[#FFEEEF] w-full flex justify-center items-center py-11">
      <div className="max-w-[1440px] flex justify-between flex-col-reverse lg:flex-row items-center px-10 w-full gap-10">
        <img src={img} alt="" />
        <div className="flex justify-center flex-col items-start gap-4">
          <h1 className="font-bold text-lightGreen-500 text-3xl md:text-5xl">
            Joanna Smieja
          </h1>
          <h2 className="font-bold text-lightGreen-500 text-xl md:text-2xl">
            MSc. ABA, BCBA
          </h2>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Joanna is a trained psychologist and a certified behavior analyst. She is passionate about working with children. 
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Over the years, she has been gaining experience in the field of child therapy using the approach of 
            behavior analysis at The Kendall Center (Modesto, USA)
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Joanna holds a degree in psychology from the California State University. She holds a Masters degree in 
            Applied Behavior Analysis from the University of Bangor. 
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Joanna is also a Board Certified Behavior Analyst (BCBA). She is currently pursuing her Ph.D.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Joanah;
